import React from "react";
import "./serve.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import ServeComponent from "../../components/serveCardsComponent/ServeComponent";
import riseImg from "../../assets/images/church/IMG_8753.jpg";
import ScrollToTop from "../../components/ScrollToTop/ScrollTopTop";

function Serve() {
  useEffect(() => {
    AOS.init(
      {
        duration: 500,
        // offet: 1000,
      },
      []
    );
  });

  return (
    <div id="super">
      <section id="serve_showcase">
        <h1 className="focus-in-contract-bck">SERVE</h1>
      </section>

      {/* ======= SECTION: SERVE_WHERE ======= */}
      <section id="serve_where">
        <div
          className="left"
          data-aos="fade-right"
          data-aos-delay="300"
          data-aos-anchor-placement="center-bottom"
        >
          <h2>SERVE WITH US!</h2>
          <p>
            Lorem, ipsum dolor sit amet consectetur adipisicing elit. Adipisci
            rem distinctio perferendis odio facilis quod veritatis dolorum?
            Asperiores cumque explicabo quos ut soluta repudiandae rerum atque
            quam molestias, voluptatibus temporibus!
          </p>
        </div>
        <div className="right">
          <div
            className="where_text"
            data-aos="slide-left"
            data-aos-anchor-placement="center-bottom"
          >
            <p
              data-aos="slide-left"
              data-aos-anchor-placement="center-bottom"
              data-aos-delay="300"
            >
              WHERE WOULD YOU LIKE TO SERVE?
            </p>
          </div>

          <div
            className="shape"
            data-aos="slide-left"
            data-aos-anchor-placement="center-bottom"
          ></div>
        </div>
      </section>

      {/* ======= SECTION: SERVE_CARDS ======= */}
      <section id="serve_cards">
        <div className="cards_wrapper">
          <div className="left">
            <ServeComponent
              img={riseImg}
              head="BOYS & GIRLS BRIGADE"
              text_1="SIGN UP"
              text_2="LEARN MORE"
              detail="Lorem, ipsum dolor sit amet consectetur adipisicing elit. Adipisci rem distinctio perferendis odio facilis quod veritatis dolorum? Asperiores cumque explicabo quos ut soluta repudiandae rerum atque quam molestias, voluptatibus temporibus!"
            />
            <ServeComponent
              img={riseImg}
              head="singing band"
              text_1="SIGN UP"
              text_2="LEARN MORE"
              detail="Lorem, ipsum dolor sit amet consectetur adipisicing elit. Adipisci rem distinctio perferendis odio facilis quod veritatis dolorum? Asperiores cumque explicabo quos ut soluta repudiandae rerum atque quam molestias, voluptatibus temporibus!"
            />
            <ServeComponent
              img={riseImg}
              head="PRAYER WARRIOR"
              text_1="SIGN UP"
              text_2="LEARN MORE"
              detail="Lorem, ipsum dolor sit amet consectetur adipisicing elit. Adipisci rem distinctio perferendis odio facilis quod veritatis dolorum? Asperiores cumque explicabo quos ut soluta repudiandae rerum atque quam molestias, voluptatibus temporibus!"
            />
            <ServeComponent
              img={riseImg}
              head="Online"
              text_1="SIGN UP"
              text_2="LEARN MORE"
              detail="Lorem, ipsum dolor sit amet consectetur adipisicing elit. Adipisci rem distinctio perferendis odio facilis quod veritatis dolorum? Asperiores cumque explicabo quos ut soluta repudiandae rerum atque quam molestias, voluptatibus temporibus!"
            />
            <ServeComponent
              img={riseImg}
              head="USHERING"
              text_1="SIGN UP"
              text_2="LEARN MORE"
              detail="Lorem, ipsum dolor sit amet consectetur adipisicing elit. Adipisci rem distinctio perferendis odio facilis quod veritatis dolorum? Asperiores cumque explicabo quos ut soluta repudiandae rerum atque quam molestias, voluptatibus temporibus!"
            />
            <ServeComponent
              img={riseImg}
              head="Creative"
              text_1="SIGN UP"
              text_2="LEARN MORE"
              detail="Lorem, ipsum dolor sit amet consectetur adipisicing elit. Adipisci rem distinctio perferendis odio facilis quod veritatis dolorum? Asperiores cumque explicabo quos ut soluta repudiandae rerum atque quam molestias, voluptatibus temporibus!"
            />
          </div>
          <div className="right">
            <ServeComponent
              img={riseImg}
              head="CHAPEL STEWARDSHIP"
              text_1="SIGN UP"
              text_2="LEARN MORE"
              detail="Lorem, ipsum dolor sit amet consectetur adipisicing elit. Adipisci rem distinctio perferendis odio facilis quod veritatis dolorum? Asperiores cumque explicabo quos ut soluta repudiandae rerum atque quam molestias, voluptatibus temporibus!"
            />
            <ServeComponent
              img={riseImg}
              head="Guest Services"
              text_1="SIGN UP"
              text_2="LEARN MORE"
              detail="Lorem, ipsum dolor sit amet consectetur adipisicing elit. Adipisci rem distinctio perferendis odio facilis quod veritatis dolorum? Asperiores cumque explicabo quos ut soluta repudiandae rerum atque quam molestias, voluptatibus temporibus!"
            />
            <ServeComponent
              img={riseImg}
              head="Student Ministry"
              text_1="SIGN UP"
              text_2="LEARN MORE"
              detail="Lorem, ipsum dolor sit amet consectetur adipisicing elit. Adipisci rem distinctio perferendis odio facilis quod veritatis dolorum? Asperiores cumque explicabo quos ut soluta repudiandae rerum atque quam molestias, voluptatibus temporibus!"
            />
            <ServeComponent
              img={riseImg}
              head="Production"
              text_1="SIGN UP"
              text_2="LEARN MORE"
              detail="Lorem, ipsum dolor sit amet consectetur adipisicing elit. Adipisci rem distinctio perferendis odio facilis quod veritatis dolorum? Asperiores cumque explicabo quos ut soluta repudiandae rerum atque quam molestias, voluptatibus temporibus!"
            />
            <ServeComponent
              img={riseImg}
              head="Kids Ministry"
              text_1="SIGN UP"
              text_2="LEARN MORE"
              detail="Lorem, ipsum dolor sit amet consectetur adipisicing elit. Adipisci rem distinctio perferendis odio facilis quod veritatis dolorum? Asperiores cumque explicabo quos ut soluta repudiandae rerum atque quam molestias, voluptatibus temporibus!"
            />
            <ServeComponent
              img={riseImg}
              head="Worship"
              text_1="SIGN UP"
              text_2="LEARN MORE"
              detail="Lorem, ipsum dolor sit amet consectetur adipisicing elit. Adipisci rem distinctio perferendis odio facilis quod veritatis dolorum? Asperiores cumque explicabo quos ut soluta repudiandae rerum atque quam molestias, voluptatibus temporibus!"
            />
          </div>
        </div>
      </section>
      <ScrollToTop />
    </div>
  );
}

export default Serve;
